/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDim1HIcon16Light } from './ArrowDim1HIcon16Light';
import { ArrowDim1HIcon16Regular } from './ArrowDim1HIcon16Regular';
import { ArrowDim1HIcon16Solid } from './ArrowDim1HIcon16Solid';
import { ArrowDim1HIcon20Light } from './ArrowDim1HIcon20Light';
import { ArrowDim1HIcon20Regular } from './ArrowDim1HIcon20Regular';
import { ArrowDim1HIcon20Solid } from './ArrowDim1HIcon20Solid';
import { ArrowDim1HIcon24Regular } from './ArrowDim1HIcon24Regular';
import { ArrowDim1HIcon24Solid } from './ArrowDim1HIcon24Solid';
import { ArrowDim1HIcon32Regular } from './ArrowDim1HIcon32Regular';
import { ArrowDim1HIcon64Regular } from './ArrowDim1HIcon64Regular';
var sizes = {
    16: {
        light: ArrowDim1HIcon16Light,
        regular: ArrowDim1HIcon16Regular,
        solid: ArrowDim1HIcon16Solid,
    },
    20: {
        light: ArrowDim1HIcon20Light,
        regular: ArrowDim1HIcon20Regular,
        solid: ArrowDim1HIcon20Solid,
    },
    24: {
        regular: ArrowDim1HIcon24Regular,
        solid: ArrowDim1HIcon24Solid,
    },
    32: {
        regular: ArrowDim1HIcon32Regular,
    },
    64: {
        regular: ArrowDim1HIcon64Regular,
    },
};
export var ArrowDim1HIcon = forwardRef('ArrowDim1HIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
